module.exports = __webpack_public_path__ + "img/cpzz15@2x.c7dcca75.png";